export class SvgUtils {
    static getSvgCoordinates(svg: SVGSVGElement, coordinates: { clientX: number; clientY: number }): SVGPoint {
        if (!svg) return null;
        const pt = svg.createSVGPoint();
        pt.x = coordinates.clientX;
        pt.y = coordinates.clientY;
        return pt.matrixTransform(svg.getScreenCTM().inverse());
    }

    /**
     * Returns the width in PX of the svg component
     * @param svg
     */
    static getSvgWidth(svg: SVGSVGElement) {
        if (!svg) return null;
        return svg.width.baseVal.value;
    }
}
